// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"370eb58d","189":"aede2469","259":"22b62f61","307":"83a82b52","396":"4283aa3d","453":"64ad871a","459":"fb9aa320","495":"00cbed04","743":"46b0738a","755":"5f309ac6","858":"cb294030","893":"5fa58a91","898":"80f39ad5","908":"86e0c244","928":"23e50c5d","955":"9e643378"}[chunkId] + ".chunk.js";
};